// 通过检测 window.AndroidShell 是否存在来判断是否在 App 环境中
import { Guid } from "@/utils/guid";
import { createStorageAdapter } from "@/utils/storages/adapter";

export const DEVICE_CODE = "YN-MOBILE-DEVICE-CODE";
export const inApp = () => typeof window !== "undefined" && !!window.AndroidShell;
/** Google Play 版本的 UA 标记 */
export const GOOGLE_PLAY_APP_UA_MARKER = "predik google";
/** 判断当前环境是否为 Google Play 版本的 App */
export const isGooglePlayApp = () =>
    typeof window !== "undefined" && window.navigator.userAgent.toLowerCase().includes( GOOGLE_PLAY_APP_UA_MARKER );
export const getDeviceCode = ( useApp = true ) => {
    if ( inApp() && useApp ) {
        return window.AndroidShell?.getAdid?.() || getDeviceCode( false );
    }
    // 先检查本地数据，如果有，返回设备信息
    const store = createStorageAdapter();
    const localCode = store.getItem( DEVICE_CODE );
    if ( localCode ) {
        return localCode;
    }
    const newAdid = Guid.create().toString();
    // deviceCode
    store.setItem( DEVICE_CODE, newAdid );
    return newAdid;
};
let _cachedAppVersion: string | null = null;
export const getNativeAppVersion = () => {
    if ( typeof window === "undefined" ) return "";
    if ( _cachedAppVersion === null ) {
        _cachedAppVersion = window.AndroidShell?.getAppVersion?.()?.trim() ?? "";
    }
    return _cachedAppVersion;
};

let _cachedChannel: string | null = null;
export const getNativeChannel = () => {
    if ( _cachedChannel === null ) {
        _cachedChannel = window.channel || window.AndroidShell?.getChannel?.() || "";
    }
    return _cachedChannel;
};

let _cachedAdid: string | null = null;
export const getNativeAdid = () => {
    if ( _cachedAdid === null ) {
        _cachedAdid = window.AndroidShell?.getAdid?.() || "";
    }
    return _cachedAdid;
};

let _cachedGpsAdid: string | null = null;
export const getNativeGpsAdid = () => {
    if ( _cachedGpsAdid === null ) {
        _cachedGpsAdid = window.AndroidShell?.getGoogleAdId?.() || "";
    }
    return _cachedGpsAdid;
};

// 登录成功后调用，刷新内存缓存
export const refreshNativeCache = () => {
    if ( !inApp() ) return;
    _cachedChannel = window.AndroidShell?.getChannel?.() || "";
    _cachedAdid = window.AndroidShell?.getAdid?.() || "";
    _cachedGpsAdid = window.AndroidShell?.getGoogleAdId?.() || "";
};

// 返回底部菜单高度
export const getNavigationBarHeight = () => {
    return 0;
    // try {
    //     if ( !window ) return 0;
    //     return ( window?.AndroidShell?.getNavigationBarHeight?.() || 0 ) / window.devicePixelRatio;
    // } catch ( e: any ) {
    //     return 0;
    // }
};

export class AndroidEvent {
    static onKeyboardShow = ( callback: AnyFunction ) => {
        try {
            window.onKeyboardShow = callback;
        } catch ( e: any ) {
            console.error( e );
        }
    };
    static onKeyboardHide = ( callback: AnyFunction ) => {
        window.onKeyboardHide = callback;
    };
}

export function getFCMTokenAsync(): Promise<string> {
    return new Promise( ( resolve ) => {
        // 1. 检查原生接口是否存在
        if ( !window.AndroidShell || typeof window.AndroidShell.getFCMToken !== "function" ) {
            console.error( "AndroidShell.getFCMToken 接口未定义" );
            return resolve( "" );
        }

        // 2. 生成一个随机且唯一的函数名，防止多次调用冲突
        const callbackName = `fcm_callback_${Date.now()}_${Math.floor( Math.random() * 1000 )}`;

        // 3. 在 window 上挂载这个临时回调函数
        window[callbackName] = function( token ) {
            resolve( token || "" ); // 成功返回 token
            // 4. 执行完后立即清理，释放内存并保持全局环境干净
            delete window[callbackName];
        };

        // 5. 调用原生接口，把刚才生成的函数名传过去
        try {
            window.AndroidShell.getFCMToken( callbackName );
        } catch ( error ) {
            delete window[callbackName];
            resolve( "" );
        }
    } );
}

export function getAdjustAttributionFromAPP() {
    const res = window.AndroidShell?.getAdjustAttribution?.();
    if ( res ) {
        try {
            return JSON.parse( res );
        } catch ( error ) {
            return null;
        }
    }
    return res;
}
